import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
    Box, Card, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Typography
 } from "@mui/material";
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import Helpers from "../Helpers";
import axios from "axios";
import CardImgProduto from "../components/CardImgProduto";


function ImgProdutos(){
    const navigate = useNavigate();
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [listaProdutos, setlistaProdutos] = useState([]);
    const [listaSubgrupos, setlistaSubgrupos] = useState([]);
    const [listaFiltrada, setListaFiltrada] = useState([]);
    const [inputPesquisa, setInputPesquisa] = useState('');

    const getAuth = ()=>{
        const data = localStorage.getItem('userAuth');

        if(data != null){
            let user = JSON.parse(data);

            if(user.tipo === 'V'){
                navigate('/clientes');
            }
        }
    };

    const getImgProdutosApi = async()=>{
        Helpers.loadingAlert('Atualizando lista de produtos');
        const rota = `${urlApi}/imagem_produto`;
        const resposta = await axios.get(rota);

        setlistaProdutos(resposta.data.produtos);
        setListaFiltrada(resposta.data.produtos);
        setlistaSubgrupos(resposta.data.subgrupos);
    };

    useEffect(() => {
        getAuth();
    }, []);

    useEffect(() => {
        if (urlApi) {
            getImgProdutosApi();
        }
    }, [urlApi]);

    const handleFiltraRegistro = (input)=>{
        Helpers.loadingAlert('Filtrando produtos');
        let registro = input;

        if(registro == ''){
            setInputPesquisa('');
            setListaFiltrada(listaProdutos);
            
            return Helpers.toastAlert({
                title: 'Lista de produtos atualizada',
                icon: 'success'
            });
        }

        const resultado = listaProdutos.filter(item => {
            let ds_registro = item.nome;
            return ds_registro.toLowerCase().includes(registro.toLowerCase());
        });

        if(resultado.length > 0){
            setListaFiltrada(resultado);
        }else{
            setListaFiltrada(listaProdutos);
            return Helpers.toastAlert({
                title: 'Nenhum registro encontrado.',
                icon: 'warning'
            });
        }

        setInputPesquisa(registro);
    };

    const filtraSubgrupo = (id) => {
        let registro = id;

        if (registro == 0) {
            setListaFiltrada(listaProdutos);
            return;
        }

        const resultado = listaProdutos.filter(item => Number(item.id_subgrupo) === Number(registro));

        if (resultado.length > 0) {
            setListaFiltrada(resultado);
        } else {
            setListaFiltrada(listaProdutos);
            return Helpers.toastAlert({
                title: 'Nenhum registro encontrado para este sub grupo',
                icon: "error",
            });
        }
    };

    return (
        <Grid container spacing={2} rowSpacing={2}>
            <Grid size={{ xs: 12, md: 6 }} offset={{ md: 3 }} >
                <FormControl fullWidth variant="outlined" sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}>
                    <InputLabel htmlFor="outlined-adornment-password">Pesquisar produto</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={'search'}
                        value={inputPesquisa}
                        onChange={(e) => setInputPesquisa(e.target.value.slice(0,120))}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={()=>handleFiltraRegistro(inputPesquisa)}
                                    edge="end"
                                >
                                    <ContentPasteSearchIcon />
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Pesquisar cliente"
                    />
                </FormControl>

                <Box sx={{ overflowX: 'auto', whiteSpace: 'nowrap', padding: 2 }}>
                    <Card
                        key={'-1'}
                        sx={{
                            display: 'inline-block',
                            minWidth: 140,
                            marginRight: 2,
                            padding: 1,
                            cursor: 'pointer'
                        }}
                        onClick={()=>filtraSubgrupo(0)}
                    >
                        <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>TODOS</Typography>
                    </Card>
                    {listaSubgrupos.map((item, index) => (
                        <Card
                            key={index}
                            sx={{
                                display: 'inline-block',
                                minWidth: 140,
                                marginRight: 2,
                                padding: 1,
                                cursor: 'pointer'
                            }}
                            onClick={()=>filtraSubgrupo(item.id)}
                        >
                            <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>{item.ds_subgrupo}</Typography>
                        </Card>
                    ))}
                </Box>
            </Grid>

            <Grid 
                size={{ xs: 12, md: 12 }} 
                sx={{ 
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: 1,
                    paddingX: 2,
                    borderBottom: '3px solid #DA0C16'
                }}
            >
                <Typography sx={{ fontWeight: 'bold' }}>{`${listaFiltrada.length} produtos encontrados`} </Typography>
            </Grid>

            <Grid container spacing={2}>
                {
                    (listaFiltrada.length > 0) &&
                    listaFiltrada.map((item, index)=>{
                        let tamanhoGrid = 4;
                        if(listaFiltrada.length <= 2){ tamanhoGrid = 12 };

                        return (
                            <Grid key={index} size={{ xs: 12, md: Number(tamanhoGrid), }}>
                                <CardImgProduto produto={item} />
                            </Grid>
                        )
                        
                    })
                }
            </Grid>
        </Grid>
    );
}

export default ImgProdutos;